import { render, staticRenderFns } from "./MortgageFrame.vue?vue&type=template&id=fecdcedc&"
import script from "./MortgageFrame.vue?vue&type=script&lang=js&"
export * from "./MortgageFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports